import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import './SubscriptionBanner.css'
import blueberryImg from '../../assets/images/banner/Group 48096056.png'
import mandarinImg from '../../assets/images/banner/Group 48096058.png'
import lemonImg from '../../assets/images/banner/Group 48096059.png'
import coconutImg from '../../assets/images/banner/Group 48096060.png'

interface SubscriptionBannerProps {
  hasSubscription?: boolean
}

const SubscriptionBanner: React.FC<SubscriptionBannerProps> = ({
  hasSubscription = false,
}) => {
  // Показываем блок только для пользователей без подписки
  if (hasSubscription) {
    return null
  }

  const showcaseRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const el = showcaseRef.current
    if (!el) return
    const center = () => {
      el.scrollLeft = (el.scrollWidth - el.clientWidth) / 2
    }
    // Чуть откладываем, чтобы размеры после загрузки картинок были корректны
    const id = requestAnimationFrame(center)
    return () => cancelAnimationFrame(id)
  }, [])

  const navigate = useNavigate()
  const handleViewInSecretChat = () => {
    navigate('/subscribe')
  }

  return (
    <div className="subscription-banner">
      <div className="subscription-banner-content">
        <div className="subscription-banner-description">
          Каждую неделю коллекция Secret Chat пополняется новыми авторскими
          рецептами в рамках темы недели
        </div>

        <div className="dessert-showcase" ref={showcaseRef}>
          <div className="dessert-card">
            <div className="dessert-image-container">
              <div
                className="dessert-image"
                style={{ backgroundImage: `url(${blueberryImg})` }}
              ></div>
            </div>
            <div className="dessert-name">Тарталетка «Кокос»</div>
          </div>
          <div className="dessert-card">
            <div className="dessert-image-container">
              <div
                className="dessert-image"
                style={{ backgroundImage: `url(${coconutImg})` }}
              ></div>
            </div>
            <div className="dessert-name">Тарталетка «Лимон»</div>
          </div>

          <div className="dessert-card">
            <div className="dessert-image-container">
              <div
                className="dessert-image"
                style={{ backgroundImage: `url(${mandarinImg})` }}
              ></div>
            </div>
            <div className="dessert-name">Тарталетка «Черника»</div>
          </div>

          <div className="dessert-card">
            <div className="dessert-image-container">
              <div
                className="dessert-image"
                style={{ backgroundImage: `url(${lemonImg})` }}
              ></div>
            </div>
            <div className="dessert-name">Тарталетка «Мандарин»</div>
          </div>
        </div>
        <div className="padding-bottom">
          <button
            className="subscribe-button "
            onClick={handleViewInSecretChat}
          >
            Смотреть в Secret Chat
          </button>
        </div>

        <div className="additional-info">
          <div className="info-text">Кстати, сейчас их там уже более 250</div>
          <ul className="categories-list">
            <li>Торты, муссовые десерты, чизкейки</li>
            <li>ПП-десерты, безглютеновые торты</li>
            <li>Классические корпусные и веганские конфеты</li>
            <li>Моти, пончики, кексы</li>
            <li>Мороженое</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default SubscriptionBanner
